import React, {useEffect, useState} from 'react';
import {jsPDF} from 'jspdf';
import { useLocation } from 'react-router-dom';
import '../App.css';
import './PDF.css';
import html2canvas from 'html2canvas';
import harrierLogo from '../images/harrer-logo.png';

const generatePDF = () => {
    const doc = new jsPDF();

    doc.text('Ankur Kumar', 10, 10);
    doc.setFont('courier');

    doc.text(20,50, 'Hello World!');

    doc.save('generated.pdf');
}

const generateHTMLtoPDF = () => {
    const input = document.getElementById('content');
    html2canvas(input, {allowTaint: true, useCORS: true}).then(canvas => {
      const imgWidth = 350;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const imgData = canvas.toDataURL('img/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save('generated.pdf');
    })
}

const PDF = () => {

  const location = useLocation();
  const payrolls = location.state;
  const [empPayroll, setEmpPayroll] = useState(payrolls[0]);

  useEffect(() => {

    payrolls.forEach((payroll) => {
      setEmpPayroll(payroll);
      const input = document.getElementById('content');
      html2canvas(input, {allowTaint: true, useCORS: true}).then(canvas => {
      const imgWidth = 380;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const imgData = canvas.toDataURL('img/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(imgData, 'PNG', 20, 20, imgWidth, imgHeight);
      pdf.save('generated.pdf');
    });
    

    });
  });
  return (
    <div style={{margin: 'auto'}}>
      {/* <button onClick={generatePDF}>Generate PDF</button>
      <button onClick={generateHTMLtoPDF}>Generate PDF from HTML</button> */}
      <div id='content' >
          <img className='logo-img' src={harrierLogo} alt='' />
          <p>First Floor, Shanti Plaza at Shanti Park,</p>
          <p>Phone: 0712-6602104, www.harriersys.com, info@harriersys.com</p>
          <p style={{margin: 'auto'}}>Salary Slip for Mon-Year</p>
          <div className='table-container1'>
              <table>
                    <tbody className='my_tbody'>
                      <tr>
                        <th className='my_th'>Name</th>
                        <td className='my_td'>{empPayroll.empPersonalDetails.first_name + ' ' +empPayroll.empPersonalDetails.last_name}</td>
                      </tr>
                      <tr>
                        <th className='my_th'>Designation</th>
                        <td className='my_td'>Developer</td>
                      </tr>
                      <tr>
                        <th className='my_th'>Total No. of Days</th>
                        <td className='my_td'>{empPayroll.empPayroll._total_days}</td>
                      </tr>
                      <tr>
                        <th className='my_th'>Gender</th>
                        <td className='my_td'>{empPayroll.empPersonalDetails.gender}</td>
                      </tr>
                    </tbody>
              </table>
              <table>
                <tbody className='my_tbody'>
                    <tr>
                      <th className='my_th'>Employee Code</th>
                      <td className='my_td'>{empPayroll.empPersonalDetails.employee_code}</td>
                    </tr>
                    <tr>
                      <th className='my_th'>Department</th>
                      <td className='my_td'>IT</td>
                    </tr>
                    <tr>
                      <th className='my_th'>ICICI A/c</th>
                      <td className='my_td'>{empPayroll.empPersonalDetails.ICICI_account_no}</td>
                    </tr>
                    <tr>
                      <th className='my_th'>PF A/c No.</th>
                      <td className='my_td'>{empPayroll.empPersonalDetails.pf_number}</td>
                    </tr>
                    <tr>
                      <th className='my_th'>ESI No.</th>
                      <td className='my_td'>{empPayroll.empPersonalDetails.ESINumber}</td>
                    </tr>
                </tbody>
              </table>
          </div>
         <div className='table-container2'>
            <table>
                <thead>
                  <tr>
                    <th className='my_th'>Earnings</th>
                    <th className='my_th'>Amount &#8377;</th>
                  </tr>
                </thead>
                <tbody className='my_tbody'>
                  {empPayroll.empSalComponents.map((salItem) => 
                    <tr>
                      <td className='my_td'>{salItem.component}</td>
                      <td className='my_td'>{salItem.Amount}</td>
                    </tr> 
                  )}
                  <tr>
                    <th className='my_th'>Total Pay &#8377;</th>
                    <th className='my_th'>{empPayroll.empPayroll.mTOTAL_EARNING}</th>
                  </tr>
                  <tr>
                    <th className='my_th'>Net Pay &#8377;</th>
                    <th className='my_th'>{empPayroll.empPayroll.mNET_SALARY}</th>
                  </tr>
                </tbody>
              </table>
              <table>

                <thead>
                  <tr>
                    <th className='my_th'>Deductions</th>
                    <th className='my_th'>Amount &#8377;</th>
                  </tr>
                </thead>
                <tbody className='my_tbody'>   
                    <tr>
                      <td className='my_td'>Profession Tax</td>
                      <td className='my_td'>{empPayroll.empPayroll.mCALCULATED_PT}</td>
                    </tr> 
                    <tr>
                      <td className='my_td'>PF</td>
                      <td className='my_td'>{empPayroll.empPayroll.mCALCULATED_PF}</td>
                    </tr>
                    <tr>
                      <td className='my_td'>VPF</td>
                      <td className='my_td'>{empPayroll.empPayroll.mCALCULATED_VPF || 0}</td>
                    </tr> 
                    <tr>
                      <th className='my_th'>Total Deductions &#8377;</th>
                      <th className='my_th'>{empPayroll.empPayroll.mTOTAL_DEDUCTION}</th>
                  </tr>
                </tbody>
              </table>
         </div>
         
      </div>
      
    </div>
    
  )
}

export default PDF
